import { searchIndividualsByName, searchCompaniesByName } from '../../../services/api/request';
import { naturalCompare } from '../../../helpers';

function getTableValue(request, key) {
    switch (key) {
        default:
            return request[key];
    }
}

export const requestTableInns = {
    namespaced: true,
    state: {
        isFetching: false,
        region: 'Все регионы',
        display: 4,
        page: 1,
        sort: {
            column: 'name',
            order: 'desc',
        },
        records: [],
    },
    mutations: {
        save(state, data) {
            state.page = 1;
            state.records = data;
        },
        setPage(state, page) {
            state.page = page;
        },
        setSort(state, sort) {
            state.sort = sort;
        },
        setFilter(state, region) {
            state.region = region || 'Все регионы';
        },
        resetState(state) {
            state.page = 1;
            state.region = 'Все регионы';
            state.records = [];
        },
        fetching(state, isFetching) {
            state.isFetching = isFetching;
        }
    },
    actions: {
        searchIndividualsByName({ commit, dispatch }, values) {
            commit('fetching', true);
            commit('setFilter');

            return searchIndividualsByName(values)
                .then((res) => {
                    commit('save', res.data);
                    commit('fetching', false);

                    return res;
                })
                .catch((res) => {
                    commit('fetching', false);
                    dispatch('error', res, { root: true });

                    throw res;
                });
        },
        searchCompaniesByName({ commit, dispatch }, name) {
            commit('fetching', true);
            commit('setFilter');

            return searchCompaniesByName(name)
                .then((res) => {
                    commit('save', res.data);
                    commit('fetching', false);

                    return res;
                })
                .catch((res) => {
                    commit('fetching', false);
                    dispatch('error', res, { root: true });

                    throw res;
                });
        },
        setPage({ commit }, page) {
            commit('setPage', page);
        },
        setSort({ commit }, sort) {
            commit('setSort', sort);
        },
        filterByRegion({ commit }, region) {
            commit('setFilter', region);
        },
        resetState({ commit }) {
            commit('resetState');
        }
    },
    getters: {
        isFetching({ isFetching, region }) {
            return isFetching;
        },

        filteredRecords({ records, region }) {
            return region === 'Все регионы'
                ? records
                : records.filter((record) => record.region === region);
        },
        totalRecords(state, { filteredRecords }) {
            return filteredRecords.length;
        },
        sortedRecords({ sort }, { filteredRecords }) {
            const sorted = filteredRecords.sort((a, b) => {
                return naturalCompare(
                    getTableValue(a, sort.column),
                    getTableValue(b, sort.column));
            });

            return sort.order === 'asc'
                ? sorted
                : sorted.reverse();
        },
        paginatedRecords({ page, display }, { sortedRecords }) {
            return sortedRecords.slice((page - 1) * display, page * display);
        },
    }
};



// WEBPACK FOOTER //
// ./src/modules/home/requestTableInns/store.js